import { CellContext } from '@tanstack/react-table'
import clsx from 'clsx'

import { DailyLogCode, DisruptionLogCode, Log, MandatoryLogInformation, MileageLossCode } from '@/types/logs'
import { MissingInfo } from './MissingInfo'
import styles from './Code.module.scss'

import DisruptionIcon from '../../../assets/disruption.svg'

interface Props extends Partial<CellContext<Log, unknown>> {
    getCodeName: (code: string) => string
    codeInput?: string
}

export const Code = ({ getValue, codeInput, row, getCodeName }: Props) => {
    const code = getValue ? getValue<string>() : codeInput

    if (!code) {
        return <MissingInfo log={row?.original} label="code" field={MandatoryLogInformation.Code} />
    }
    const isMileageLossCode = code in MileageLossCode
    const isDisruptionLog = code.toLocaleLowerCase() === DisruptionLogCode.Disruption
    const isCodeRedOrBlue = code === DailyLogCode.CodeBlue || code === DailyLogCode.CodeRed
    const isDefaultCode = !isMileageLossCode && !isDisruptionLog && !isCodeRedOrBlue

    return (
        <div
            className={clsx(styles.root, {
                [styles.default]: isDefaultCode,
                [styles[`code${code?.toUpperCase()}`]]: isMileageLossCode || isCodeRedOrBlue,
                [styles.disruption]: isDisruptionLog,
            })}
        >
            {isDisruptionLog && <DisruptionIcon />}
            <span>{getCodeName(code) ?? '-'}</span>
        </div>
    )
}
